interface V3IconRemoveFromProfileProps extends React.SVGProps<SVGSVGElement> {
}

export const V3IconRemoveFromProfile = ({ }: V3IconRemoveFromProfileProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.25 2H2.75a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75V2.75a.75.75 0 0 0-.75-.75ZM2 5h12M5 2v3" stroke="#ABB0BA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m5 12 3-4 3 4" stroke="#ABB0BA" strokeWidth="1.5" />
    <path d="m11 11 4 4M15 11l-4 4" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m11 11 4 4M15 11l-4 4" stroke="#ABB0BA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>